module.exports = __webpack_public_path__ + "static/media/EGD3.6ee9fe93.jpg";